import { ClientFileReferenceOrNullSchema } from '@/agent/references/store/schemas'
import { z } from 'zod'

export const UserFileReferenceViewerResponseSchema = z.object({
  reference_id: z.string().uuid(),
  conversation_id: z.string().uuid(),
  matter_id: z.string().uuid(),
  file_reference: ClientFileReferenceOrNullSchema,
})

export type UserFileReferenceViewerResponse = z.infer<typeof UserFileReferenceViewerResponseSchema>
